import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { ComponentSettingKey } from '@/shared/builder'
import { getSafely } from '@/shared/safely'

import { CompNewsletterWrapperCore } from '../core/newsletter/wrapper'

function CompNewsletterWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const action = useBuilderActionContextV2()

  return <CompNewsletterWrapperCore infos={infosProps} action={action} />
}

export { CompNewsletterWrapper }
